import { render } from "./ProductsForm.vue?vue&type=template&id=61abb0b5&scoped=true"
import script from "./ProductsForm.vue?vue&type=script&lang=js"
export * from "./ProductsForm.vue?vue&type=script&lang=js"

import "./ProductsForm.vue?vue&type=style&index=0&id=61abb0b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61abb0b5"]])

export default __exports__